import React, { Component } from 'react'
import classNames from 'classnames'
import fetch from 'lib/fetch'

import { CloseButton } from 'components/buttons'
import NudgeBar from 'components/nudge-bar'
import Image from 'components/image'

import css from './banner.scss'

class Banner extends Component {
  state = { show: true }

  render() {
    return this.isInUnitedKingdom() ? (
      <div className={classNames(css.bannerWrapper)}>
        <div className="container">
          <NudgeBar
            animated
            show={this.state.show}
            delayBeforeAnimation={500}
            color={css.bannerColor}
            contentWrapperClassName={css.contentWrapper}
          >
            <div className={classNames('text-inverse', css.messageWrapper)}>
              Looking for Babylist in London, England?{' '}
              <br className="visible-xs-inline" />
              They are now called Anita's House.{' '}
              <br className="visible-xs-inline visible-sm-inline" />
              Find them at{' '}
              <a
                href="http://www.anitashouse.com"
                className={classNames('link-inverse', css.siteLink)}
                target="_blank"
                rel="noopener noreferrer"
              >
                anitashouse.com
              </a>
              {'.'}
            </div>
            <div className={css.rightNavWrapper}>
              <div
                className={classNames(
                  'visible-md-inline-block visible-lg-inline-block',
                  css.logoWrapper
                )}
              >
                <a
                  href="http://www.anitashouse.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    src="https://res.cloudinary.com/babylist/image/upload/v1474566944/anitas-house-logo_slcwgr.png"
                    alt="Anita's House Logo"
                  />
                </a>
              </div>
              <CloseButton
                className={css.closeButton}
                onClick={this.handleClose.bind(this)}
              />
            </div>
          </NudgeBar>
        </div>
      </div>
    ) : null
  }

  isInUnitedKingdom() {
    let tzOffsetHrs = this.getTZOffsetHrs()
    // if we are within 1 hour of UTC show the banner
    if (tzOffsetHrs < 2) {
      return true
    }
    return false
  }

  getTZOffsetHrs() {
    return Math.abs(new Date().getTimezoneOffset()) / 60
  }

  handleClose() {
    this.setState({ show: false })
  }
}

export default Banner
